import assignmentService from 'ApiService/Teacher/Assignment';
import testService from 'ApiService/Teacher/TestService';
import DateField from 'components/fields/dateField';
import { AuthContext } from 'contexts/AuthContext';
import Nodatafound from 'pages/Common/Nodatafound';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';

const MultiSelect = ({ options, selected = [], onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(!isOpen);

  const handleSelect = (batchId) => {
    const updatedSelection = selected.includes(batchId)
      ? selected.filter((id) => id !== batchId)
      : [...selected, batchId];
    onChange(updatedSelection);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  return (
    <div className="relative" onMouseLeave={handleMouseLeave}>
      <div
        className="flex cursor-pointer flex-wrap gap-2 rounded-md border p-2"
        onClick={handleToggle}
      >
        {selected.map((batchId) => {
          const batch = options.find((b) => b._id === batchId);
          return (
            <span key={batchId} className="rounded-md bg-brand-500 px-2 py-2">
              Batch {batch?.batchNumber}
              <button
                className="ml-2 text-xs"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelect(batchId);
                }}
              >
                ×
              </button>
            </span>
          );
        })}
        {selected.length === 0 && (
          <span className="text-gray-400 ">Select batches</span>
        )}
      </div>
      {isOpen && (
        <div
          className="mt-1 max-h-60 w-full overflow-y-auto rounded-md border bg-brand-500"
          onMouseEnter={() => setIsOpen(true)}
        >
          {options.map((option) => (
            <div
              key={option._id}
              className={`cursor-pointer p-2 ${
                selected.includes(option._id) ? 'bg-brand-600 ' : ''
              }`}
              onClick={() => handleSelect(option._id)}
            >
              <input
                type="checkbox"
                checked={selected.includes(option._id)}
                onChange={() => {}}
                className="mr-2"
              />
              Batch {option.batchNumber}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const SelectAssignment = ({
  testData,
  selectedTest,
  setSelectedBatches,
  setSelectedTest,
  selectedBatches,
  setTestSchedule,
  testSchedule,
  setscheduledAt,
  scheduledAt,
}) => {
  const [tests, setTests] = useState([]);
  const [batches, setBatches] = useState([]);
  const { state } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [filterType, setFilterType] = useState('mcq');
  console.log(filterType, 'filterType');
  const fetchTests = async () => {
    if (!testData.courseId) {
      setTests([]);
      return;
    }
    setLoading(true);
    try {
      const response = await assignmentService.assignmentByTeacherCourse(
        testData.courseId
      );
      if (response.data.success) {
        setTests(response.data.data);
      } else {
        toast.error(response.data.message || 'Failed to fetch tests.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch tests.');
    } finally {
      setLoading(false);
    }
  };

  const fetchBatches = async () => {
    if (!testData.courseId) {
      setBatches([]);
      return;
    }
    try {
      const response = await testService.getBatchesByCourse(testData.courseId);
      if (response.data.success) {
        setBatches(response.data.batches);
      } else {
        toast.error(response.data.message || 'Failed to fetch batches.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch batches.');
    }
  };

  useEffect(() => {
    if (state?.user && testData.courseId) {
      fetchTests();
      fetchBatches();
    }
  }, [state?.user, testData.courseId]);

  const handleBatchChange = (selectedBatchIds) => {
    setSelectedBatches(selectedBatchIds);
  };

  const handleTestSelection = (test) => {
    setSelectedTest(test);
  };

  const handleScheduleTypeChange = (e) => {
    setTestSchedule(e.target.value);
  };

  const filteredTests = tests.filter((t) => t.type === filterType);

  if (!testData.courseId) {
    return <Nodatafound title="Please select a course first" />;
  }

  const handleDateChange = (e) => {
    setscheduledAt(e.target.value);
    console.log(e.target.value, 'e.target.value');
  };

  return (
    <div className="mt-4 h-full w-full rounded-[20px] p-4 md:mt-5">
      <div className="mb-4">
        <label className="mb-2 block text-sm font-bold text-gray-700">
          Select Batches to Assign
        </label>
        <MultiSelect
          options={batches}
          selected={selectedBatches}
          onChange={handleBatchChange}
        />
      </div>

      <div className="mb-4">
        <label className="mb-2 block text-sm font-bold text-gray-700">
          Select Schedule Type
        </label>
        <select
          className="w-full rounded-md border p-2 dark:bg-navy-800"
          value={testSchedule}
          onChange={handleScheduleTypeChange}
        >
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
          <option value="end assignment">End Assignment</option>
        </select>
      </div>

      <div>
        <DateField
          extra="mb-3"
          label="Schedule At"
          id="scheduledAt"
          value={scheduledAt}
          onChange={handleDateChange}
        />
      </div>

      <div
        className="mb-4 flex justify-start"
        style={{ position: 'relative', zIndex: '9999' }}
      >
        <button
          className={`mr-2 rounded-lg px-4 py-2 ${
            filterType === 'mcq'
              ? 'bg-blue-500 text-white'
              : 'bg-gray-200 dark:text-navy-800'
          }`}
          onClick={() => setFilterType('mcq')}
        >
          MCQ
        </button>
        <button
          className={`rounded-lg px-4 py-2 ${
            filterType === 'qa'
              ? 'bg-blue-500 text-white'
              : 'bg-gray-200 dark:text-navy-800'
          }`}
          onClick={() => setFilterType('qa')}
        >
          QA
        </button>
      </div>

      {loading ? (
        <div className="flex h-40 items-center justify-center">
          <BallTriangle color="#5431ed" />
        </div>
      ) : filteredTests.length === 0 ? (
        <div className="flex h-40 items-center justify-center dark:text-gray-600">
          <Nodatafound
            title={`No ${filterType.toUpperCase()} Assignment found for this course`}
          />
        </div>
      ) : (
        <div className="grid h-full w-full grid-cols-1 gap-4 p-2 md:grid-cols-2 lg:grid-cols-3">
          {filteredTests.map((test) => (
            <div
              key={test._id}
              onClick={() => handleTestSelection(test._id)}
              className={`relative flex h-full cursor-pointer flex-col items-center rounded-lg border border-gray-200 p-4 dark:border-gray-700  md:flex-row ${
                selectedTest === test._id ? ' bg-brand-500 text-white' : ''
              }`}
            >
              <div className="flex h-full w-full flex-col leading-normal md:w-2/3">
                <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  {test.title}
                </h5>
                <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                  Total Questions: {test.questions.length}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectAssignment;
